import { MetadataDocumentMapping } from '@/utils/mappings';
import { resolveId } from '@/utils/resolvers';
import React, { memo, useRef } from 'react';
import CMSPlaceholder from '../shared/CMSPlaceholder';
import CMSWrapper from '../shared/CMSWrapper';
import SEOHrefLang from '../shared/SEOHrefLang';
import SEO from './SEO';

const MappedSEO = memo(({ content, isPreview, pageModels, contentButtons }: any) => {
  const translationConfig = pageModels?.config?.translation;
  const {
    tags = [],
    contentCategory,
    metadata,
    customTags,
    releaseDate,
    publicationDate,
    podcastSeries,
  } = content;
  const { httpStatusCode } = pageModels;

  const hrefLangProps = React.useMemo(
    () => ({
      hrefLangsRaw: metadata?.hreflangUrl,
      exclusionPaths: translationConfig?.endpoint_exclusion_paths,
      countryCodesWhitelist: translationConfig?.country_codes_whitelist,
    }),
    [
      metadata?.hreflangUrl,
      translationConfig?.endpoint_exclusion_paths,
      translationConfig?.country_codes_whitelist,
    ],
  );

  return (
    <>
      {isPreview && (
        <CMSPlaceholder componentName="SEO" message="" contentButtons={contentButtons} />
      )}
      <SEO
        metadata={metadata}
        tags={tags}
        customTags={customTags}
        releaseDate={releaseDate}
        publicationDate={publicationDate}
        podcastSeries={podcastSeries}
        contentCategory={contentCategory}
        httpStatusCode={httpStatusCode}
      />
      <SEOHrefLang {...hrefLangProps} />
    </>
  );
});

const SEOCMSWrapper = (brProps: any) => {
  const mapping = useRef({
    document: [
      'content',
      {
        metadataCompound: ['metadata', MetadataDocumentMapping],
        contentcategory: 'contentCategory',
        keys: 'tags',
        customtags: 'customTags',
        releaseDate: 'releaseDate',
        publicationDate: 'publicationDate',
        podcastSeries: 'podcastSeries',
        id: [null, resolveId],
        localeString: 'langCodeDefault',
      },
    ],
  });

  const requiredFields = useRef({
    document: '<b>Metadata Content</b> required',
  });

  const contentButtonNames = useRef({
    document: 'content',
  });

  return (
    <CMSWrapper
      componentName="SEO"
      brProps={brProps}
      render={MappedSEO}
      mapping={mapping.current}
      requiredFields={requiredFields.current}
      contentButtonNames={contentButtonNames.current}
    />
  );
};

export default SEOCMSWrapper;
